import React from "react";

import "./style.scss";
import logo from "assets/cemlogo.png";

export const NotFoundPage = () => {
	return (
		<div className="notFound">
			<div className="notFound__container">
				<div className="notFound__container__header">
					<img src={logo} alt="logo" />
				</div>

				<div className="notFound__container__message">
					<h1>Página não encontrada.</h1>
				</div>
			</div>
		</div>
	);
};
